import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';

import GamesWorkshopStockcheck from './containers/GamesWorkshopStockcheck';

const routes = [
    {
        type: 'simple',
        name: 'gamesworkshop-stockcheck',
        view: GamesWorkshopStockcheck,
        path: '/reports/gamesworkshop-stockcheck'
    }
]

export default ModuleBootstrapper.getRoutes("gamesworkshop", routes)
